import { useState, useEffect } from "react";
import {
  Lock,
  CheckCircle2,
  User,
  MessageSquare,
  RefreshCcw,
  Smile,
  Bell,
  Phone,
  FileText,
  AlertTriangle,
  Lightbulb,
  PenTool,
  Sparkles,
} from "lucide-react";
  import Toast from "../components/Toast";
import { data } from "react-router-dom";



function BotSettings() {

const [toast, setToast] = useState({
  message: "",
  type: "success",
});
  const [botActive, setBotActive] = useState(true);
  const [handoverKeyword, setHandoverKeyword] = useState("");
  const [resumeKeyword, setResumeKeyword] = useState("");
  const [botName, setBotName] = useState("Zuccess Assistant");
  const [language, setLanguage] = useState("English");
  const [workType, setWorkType] = useState("Support");
  const [botRole, setBotRole] = useState("Assistant");
  const [replyStyle, setReplyStyle] = useState("");
  const [replyLength, setReplyLength] = useState("");
  const [replySpeed, setReplySpeed] = useState("Natural");
  const [useEmojis, setUseEmojis] = useState(true);
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [notificationDetails, setNotificationDetails] = useState("");
  const [systemPrompt, setSystemPrompt] = useState("");
  const [conversationStarter, setConversationStarter] = useState("");
  const [websiteLink, setWebsiteLink] = useState("");
  const [botsitings, setBotsitings] = useState({})
  const API_BASE = "https://zaichat.net/api";


  useEffect(() => {
  
    fetchSittings();
  }, []);


  const fetchSittings = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE}/data`, {
        headers: { auth: `Bearer ${token}` },
      });
      const data = await response.json();
      console.log(data.data)
      setBotsitings(data.data || []);

      setHandoverKeyword(data.data.handover_keyword);
setResumeKeyword(data.data.resume_keyword);
setBotName(data.data.name);
setLanguage(data.data.lang);
setWorkType(data.data.work_type);
setBotRole(data.data.bot_role);
setReplyStyle(data.data.replay_style);
setReplyLength(data.data.replay_length);
setUseEmojis(data.data.emogeis);
setWhatsappNumber(data.data.owner_number);
setNotificationDetails(data.data.data_notify);
setConversationStarter(data.data.Welcome_message);
setWebsiteLink(data.data.website_link);
setSystemPrompt(data.data.system_prompt);
    } catch (error) {
      console.error(error);
    } 
  };
  const handleEnhancePrompt =async () => {
    alert("✨ AI will enhance your system prompt soon!");
    const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE}/enhance-prompt`, {
        headers: { auth: `Bearer ${token}`,"Content-Type": "application/json" },
        method:"POST",
        body: JSON.stringify({
          "system_prompt": systemPrompt
        })
      });
      const data = await response.json();
      console.log(data.data.enhanced_prompt)
      setSystemPrompt(data.data.enhanced_prompt || []);
  };


const saveBotSitings = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await fetch(`${API_BASE}/data`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        auth: `Bearer ${token}`,
      },
      body: JSON.stringify({
        handover_keyword: handoverKeyword,
        resume_keyword: resumeKeyword,
        chatbot_number: whatsappNumber,
        sys_prompt: {
          name: botName,
          bot_role: botRole,
          work_type: workType,
          lang: language,
          website_link: websiteLink,
          Welcome_message: conversationStarter,
          replay_style: replyStyle,
          replay_length: replyLength,
          emogeis: useEmojis,
          data_notify: notificationDetails,
          instructions: systemPrompt,
          whatsapp_number: whatsappNumber,
        },
      }),
    });

    const data = await res.json()

    console.log(data)
    if (!res.ok) throw new Error("Save failed");

    setToast({
      message: "✅ Settings saved successfully",
      type: "success",
    });

  } catch (error) {
    setToast({
      message: "❌ Failed to save settings",
      type: "error",
    });
  }

  setTimeout(() => {
    setToast({ message: "", type: "success" });
  }, 3000);
};



const activeDeActive = async() =>{

  console.log(!botActive)
  setBotActive(!botActive)

  const token = localStorage.getItem("token")
 
  const res = await fetch(`${API_BASE}/bot_status`, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    auth: `Bearer ${token}`
  },
  body: JSON.stringify({
    status: botActive
  })

})

const data =await res.json()

console.log(data)





}
  return (
    <div className="min-h-screen bg-cream text-primary py-10 px-6 md:px-10">
      <div className="bg-white rounded-2xl shadow-lg border-t-4 border-accent p-10">
        
        <div className="mb-10 text-center">
          <h1 className="text-3xl md:text-4xl font-extrabold text-primary mb-3">
            Bot Settings
          </h1>
          {toast.message && (
  <Toast
    message={toast.message}
    type={toast.type}
  />
)}
          <p className="text-dark/70 text-lg">
            Manage all your chatbot’s information, behavior, and preferences in one place.
          </p>
        </div>

        {/* Control & Activation */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <CheckCircle2 className="text-accent w-6 h-6" />
            <h2 className="text-2xl font-bold text-primary">Control & Activation</h2>
          </div>
{/* 
          <div className="flex items-center justify-between mb-6">
            <p className="font-medium text-dark/80">Bot Status</p>
            <button
              onClick={activeDeActive}
              className={`w-14 h-8 flex items-center rounded-full p-1 transition-all ${
                botActive ? "bg-accent" : "bg-gray-300"
              }`}
            >
              <div
                className={`w-6 h-6 bg-white rounded-full shadow-md transform transition-transform ${
                  botActive ? "translate-x-6" : "translate-x-0"
                }`}
              />
            </button>
          </div> */}

          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="flex items-center gap-2 text-sm font-semibold text-dark/80 mb-2">
                <Lock size={16} className="text-accent" /> Handover Keyword
              </label>
              <input
                type="text"
                value ={handoverKeyword}
                onChange={(e) => setHandoverKeyword(e.target.value)}
                placeholder="Keyword that stops the bot..."
                className="w-full border border-accent/30 rounded-lg p-3 text-sm focus:outline-none focus:border-accent"
              />
              <p className="text-xs text-dark/60 mt-2">
                🔒 This keyword is used to pause the bot.
              </p>
            </div>

            <div>
              <label className="flex items-center gap-2 text-sm font-semibold text-dark/80 mb-2">
                <RefreshCcw size={16} className="text-accent" /> Resume Keyword
              </label>
              <input
                type="text"
                value={resumeKeyword}
                onChange={(e) => setResumeKeyword(e.target.value)}
                placeholder="Keyword that resumes the bot..."
                className="w-full border border-accent/30 rounded-lg p-3 text-sm focus:outline-none focus:border-accent"
              />
              <p className="text-xs text-dark/60 mt-2">
                🔄 This keyword reactivates the bot.
              </p>
            </div>
          </div>
        </div>

        {/* Basic Information */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <User className="text-accent w-6 h-6" />
            <h2 className="text-2xl font-bold text-primary">Basic Information</h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="text-sm font-semibold text-dark/80 mb-2 block">
                Bot Name
              </label>
              <input
                type="text"
                value={botName}
                onChange={(e) => setBotName(e.target.value)}
                className="w-full border border-primary/30 rounded-lg p-3 text-sm focus:outline-none focus:border-accent"
              />
            </div>

            <div>
              <label className="text-sm font-semibold text-dark/80 mb-2 block">
                Default Language
              </label>
              <select
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                className="w-full border border-primary/30 rounded-lg p-3 text-sm focus:outline-none focus:border-accent"
              >
                <option>English</option>
                <option>Arabic</option>
                <option>French</option>
                <option>Spanish</option>
              </select>
            </div>

            <div>
              <label className="text-sm font-semibold text-dark/80 mb-2 block">
                Work Type
              </label>
              <select
                value={workType}
                onChange={(e) => setWorkType(e.target.value)}
                className="w-full border border-primary/30 rounded-lg p-3 text-sm focus:outline-none focus:border-accent"
              >
                <option>Support</option>
                <option>Sales</option>
                <option>Marketing</option>
                <option>Education</option>
              </select>
            </div>

            <div>
              <label className="text-sm font-semibold text-dark/80 mb-2 block">
                Bot Role
              </label>
              <input
                type="text"
                value={botRole}
                onChange={(e) => setBotRole(e.target.value)}
                placeholder="Assistant, Consultant..."
                className="w-full border border-primary/30 rounded-lg p-3 text-sm focus:outline-none focus:border-accent"
              />
            </div>
          </div>
        </div>

        {/* Reply Behavior */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <MessageSquare className="text-accent w-6 h-6" />
            <h2 className="text-2xl font-bold text-primary">Reply Behavior</h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-semibold text-dark/80 mb-2">
                Reply Style
              </label>
              <input
                type="text"
                value={replyStyle}
                onChange={(e) => setReplyStyle(e.target.value)}
                placeholder="Friendly, Formal, Witty..."
                className="w-full border border-primary/30 rounded-lg p-3 text-sm focus:outline-none focus:border-accent"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-dark/80 mb-2">
                Reply Length
              </label>
              <input
                type="text"
                value={replyLength}
                onChange={(e) => setReplyLength(e.target.value)}
                placeholder="Short, Medium, Detailed..."
                className="w-full border border-primary/30 rounded-lg p-3 text-sm focus:outline-none focus:border-accent"
              />
            </div>
          </div>

          <div className="flex items-center gap-6 mt-5 flex-wrap">

            <div className="flex items-center gap-3">
              <label className="flex items-center gap-2 text-sm font-semibold text-dark/80">
                <Smile size={18} className="text-accent" /> Use Emojis
              </label>
              <button
                value={useEmojis}
                onClick={() => setUseEmojis(!useEmojis)}
                className={`w-14 h-8 flex items-center rounded-full p-1 transition-all ${
                  useEmojis ? "bg-accent" : "bg-gray-300"
                }`}
              >
                <div
                  className={`w-6 h-6 bg-white rounded-full shadow-md transform transition-transform ${
                    useEmojis ? "translate-x-6" : "translate-x-0"
                  }`}
                />
              </button>
            </div>
          </div>
        </div>

        {/* Notifications */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <Bell className="text-accent w-6 h-6" />
            <h2 className="text-2xl font-bold text-primary">
              Notifications & Alerts
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="flex items-center gap-2 text-sm font-semibold text-dark/80 mb-2">
                <Phone size={16} className="text-accent" /> WhatsApp Number
              </label>
              <input
                type="text"
                value={whatsappNumber}
                onChange={(e) => setWhatsappNumber(e.target.value)}
                placeholder="e.g., 00966553156937"
                className="w-full border border-accent/30 rounded-lg p-3 text-sm focus:outline-none focus:border-accent"
              />
              <p className="text-xs text-dark/60 mt-2 flex items-center gap-2">
                <AlertTriangle size={14} className="text-accent" />
                Use a different number from your bot’s number.
              </p>
            </div>

            <div>
              <label className="flex items-center gap-2 text-sm font-semibold text-dark/80 mb-2">
                <FileText size={16} className="text-accent" /> Data in Notifications
              </label>
              <textarea
                rows="3"
                value={notificationDetails}
                onChange={(e) => setNotificationDetails(e.target.value)}
                placeholder="Client name, order number, service type..."
                className="w-full border border-accent/30 rounded-lg p-3 text-sm focus:outline-none focus:border-accent"
              />
            </div>
          </div>
        </div>

        {/* Conversation Starter + Website */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <MessageSquare className="text-accent w-6 h-6" />
            <h2 className="text-2xl font-bold text-primary">
              Conversation Starter & Website
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            
            <div>
              <label className="block text-sm font-semibold text-dark/80 mb-2">
                Conversation Starter
              </label>
              <textarea
                rows="3"
                value={conversationStarter}
                onChange={(e) => setConversationStarter(e.target.value)}
                placeholder="Example: Hi! 👋 How can I help you?"
                className="w-full border border-primary/30 rounded-lg p-3 text-sm focus:outline-none focus:border-accent"
              />
              <p className="text-xs text-dark/60 mt-2">
                This message is sent automatically when a new chat starts.
              </p>
            </div>

            <div>
              <label className="block text-sm font-semibold text-dark/80 mb-2">
                Website Link
              </label>
              <input
                type="text"
                value={websiteLink}
                onChange={(e) => setWebsiteLink(e.target.value)}
                placeholder="https://www.yourwebsite.com"
                className="w-full border border-primary/30 rounded-lg p-3 text-sm focus:outline-none focus:border-accent"
              />
              <p className="text-xs text-dark/60 mt-2">
                Add your company website for bot profile and interactions.
              </p>
            </div>

          </div>
        </div>

        {/* System Prompt */}
        <div>
          <div className="flex items-center gap-3 mb-5">
            <FileText className="text-accent w-6 h-6" />
            <h2 className="text-2xl font-bold text-primary">
              System Prompt (Chatbot Instructions)
            </h2>
          </div>

          {/* Instructional boxes */}
          <div className="grid md:grid-cols-2 gap-6 mb-8">
            <div className="bg-cream border border-primary/20 rounded-xl p-5 shadow-sm">
              <h3 className="flex items-center gap-2 text-primary font-semibold mb-2">
                <Lightbulb className="w-5 h-5 text-accent" /> What is a System Prompt?
              </h3>
              <p className="text-dark/70 text-sm leading-relaxed">
                It defines your chatbot’s role, tone, and rules.
              </p>
            </div>

            <div className="bg-cream border border-primary/20 rounded-xl p-5 shadow-sm">
              <h3 className="flex items-center gap-2 text-primary font-semibold mb-2">
                <PenTool className="w-5 h-5 text-accent" /> How to Write It?
              </h3>
              <p className="text-dark/70 text-sm leading-relaxed">
                Example: “You are a helpful support assistant that answers politely.”
              </p>
            </div>
          </div>

          <textarea
            rows="6"
            value={systemPrompt}
            onChange={(e) => setSystemPrompt(e.target.value)}
            placeholder="Write your system prompt here..."
            className="w-full border border-accent/30 rounded-lg p-4 text-sm focus:outline-none focus:border-accent"
          />

          <div className="flex justify-end mt-4">
            <button
              onClick={handleEnhancePrompt}
              className="flex items-center gap-2 bg-primary text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-primary/90 transition"
            >
              <Sparkles size={16} className="text-accent" />
              Enhance with AI
            </button>
          </div>
        </div>

        {/* Save Button */}
        <div className="mt-10 text-center">
          <button onClick={(e)=>{saveBotSitings()}} className="bg-accent text-white py-3 px-8 rounded-lg font-semibold hover:bg-accent/90 transition">
            Save All Settings
          </button>
        </div>

      </div>
    </div>
  );
}


function KnowledgeBase() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [files, setFiles] = useState([]);
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [deletingFile, setDeletingFile] = useState(null);

  const API_BASE = "https://zaichat.net/api";

  useEffect(() => {
    fetchFiles();
  }, []);

  const fetchFiles = async () => {
    setIsLoadingFiles(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE}/knowledgebase/files`, {
        headers: { auth: `Bearer ${token}` },
      });
      const data = await response.json();
      setFiles(data.data.files || []);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingFiles(false);
    }
  };

    

  const handleDeleteFile = async (filename) => {
    setDeletingFile(filename);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${API_BASE}/knowledgebase/files?filename=${filename}`,
        {
          method: "DELETE",
          headers: { auth: `Bearer ${token}` },
        }
      );

      const data = await response.json();
      setUploadStatus({
        type: "success",
        message: `File "${filename}" deleted!`,
      });

      fetchFiles();

      setTimeout(() => setUploadStatus(null), 3000);
    } catch (error) {
      setUploadStatus({
        type: "error",
        message: "Failed to delete file.",
      });
      setTimeout(() => setUploadStatus(null), 5000);
    } finally {
      setDeletingFile(null);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") setDragActive(true);
    else if (e.type === "dragleave") setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      setSelectedFile(file);
      setUploadStatus(null);
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    setUploadStatus(null);
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    setUploadStatus(null);
  };

  const handleUpload = async () => {
    if (!selectedFile) return;
    setIsUploading(true);
    setUploadStatus(null);

    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("file", selectedFile);

      const response = await fetch(`${API_BASE}/upload`, {
        method: "POST",
        headers: { auth: `Bearer ${token}` },
        body: formData,
      });

      const data = await response.json();

      setUploadStatus({
        type: "success",
        message: `Uploaded: ${data.chunks_uploaded} chunks added.`,
      });

      fetchFiles();

      setTimeout(() => {
        setSelectedFile(null);
        setUploadStatus(null);
      }, 3000);
    } catch {
      setUploadStatus({
        type: "error",
        message: "Upload failed.",
      });
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-amber-50 text-gray-800 py-10 px-6 md:px-10">

      <div className="max-w-4xl mx-auto mt-14 mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Knowledge Base Manager
        </h1>
        <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg">
          <p className="text-blue-800 text-sm">
            Upload documents to train your AI assistant.
          </p>
        </div>
      </div>

      {/* Upload Area */}
      <div className="max-w-4xl mx-auto mb-12">
        {!selectedFile ? (
          <div
            className={`border-2 border-dashed rounded-2xl p-12 text-center ${
              dragActive ? "border-orange-500 bg-orange-50" : "border-gray-300"
            }`}
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
            onDragOver={handleDrag}
            onDrop={handleDrop}
            onClick={() => document.getElementById("fileInput").click()}
          >
            <h4 className="text-xl font-semibold mb-2">Drag & drop your file</h4>
            <p className="text-gray-500 mb-4">or click to browse</p>
            <input
              type="file"
              id="fileInput"
              className="hidden"
              onChange={handleFileSelect}
              accept=".md,.pdf,.docx,.txt"
            />
          </div>
        ) : (
          <div className="bg-orange-50 p-8 rounded-2xl text-center">
            <h5 className="text-lg font-semibold mb-1">{selectedFile.name}</h5>
            <p className="text-sm mb-6">{(selectedFile.size / 1024).toFixed(2)} KB</p>

            <div className="flex justify-center gap-4">
              <button
                className="px-5 py-2 rounded-full border border-red-400 text-red-500"
                onClick={handleRemoveFile}
                disabled={isUploading}
              >
                Cancel
              </button>
              <button
                className="px-6 py-2 rounded-full bg-orange-500 text-white font-semibold"
                onClick={handleUpload}
                disabled={isUploading}
              >
                {isUploading ? "Processing..." : "Upload"}
              </button>
            </div>
          </div>
        )}

        {uploadStatus && (
          <div
            className={`mt-5 p-4 rounded-lg text-sm font-medium ${
              uploadStatus.type === "success"
                ? "bg-green-100 text-green-800"
                : "bg-red-100 text-red-700"
            }`}
          >
            {uploadStatus.message}
          </div>
        )}
      </div>

      {/* Uploaded Files */}
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">Your Knowledge Base</h2>

        <div className="bg-white p-6 rounded-2xl shadow">
          {isLoadingFiles ? (
            <p className="text-center">Loading...</p>
          ) : files.length === 0 ? (
            <p className="text-center text-gray-500">No files uploaded yet.</p>
          ) : (
            <ul className="space-y-3">
              {files.map((filename) => (
                <li
                  key={filename}
                  className="p-4 bg-orange-50 rounded-xl flex justify-between items-center"
                >
                  <span>{filename}</span>
                  <button
                    className="text-red-500"
                    onClick={() => handleDeleteFile(filename)}
                  >
                    Delete
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

    </div>
  );
}

export default function BotSettingsPage() {
  const [activeTab, setActiveTab] = useState("settings");

  return (
    <div className="min-h-screen bg-gray-100 p-6">

      {/* Tabs Navigation */}
      <div className="bg-white p-2 rounded-xl shadow flex gap-2 mb-6">
        <button
          onClick={() => setActiveTab("settings")}
          className={`flex-1 py-3 rounded-lg font-semibold ${
            activeTab === "settings"
              ? "bg-orange-500 text-white"
              : "bg-gray-100 text-gray-700"
          }`}
        >
          Bot Settings
        </button>

        <button
          onClick={() => setActiveTab("knowledge")}
          className={`flex-1 py-3 rounded-lg font-semibold ${
            activeTab === "knowledge"
              ? "bg-orange-500 text-white"
              : "bg-gray-100 text-gray-700"
          }`}
        >
          Knowledge Base
        </button>
      </div>

      {/* Tabs Content */}
      <div className="bg-white rounded-xl shadow p-4">
        {activeTab === "settings" ? <BotSettings /> : <KnowledgeBase />}
      </div>

    </div>
  );
}
